import {Auftragsverwaltung} from "../../../stores/auftragsverwaltung-mobx";
import {observer} from "mobx-react";
import {Component} from "react";
import {Button} from "semantic-ui-react";
import * as React from "react";
import {Icon} from "../../../core/components/icon/icon";

import {AppState} from "../app-mobx";


export interface MapToggleButtonProps {
    auftragsverwaltung: Auftragsverwaltung;
    appStore: AppState;
}

@observer
export class MapToggleButton extends Component<MapToggleButtonProps, any> {

    constructor(props: MapToggleButtonProps) {
        super(props);
        this.state = {};
        this.handleToggleMap = this.handleToggleMap.bind(this);
    }

    render(): React.ReactElement | null {
        const {auftragsverwaltung, appStore} = this.props;

	    if (auftragsverwaltung.isEditingPerimeter) {
            // do not show button when editing
		    return null;
	    }

        if (appStore.topic.id === "map" ||
			appStore.topic.id === "auftragsverwaltung") {
            // map always open. do not toggle
            return null;
        }

	    if (appStore.topic.id === "journal" ||
		    appStore.topic.id === "contractors") {
		    // map not needed
		    return null;
	    }

        if ((appStore.topic.id === "projectsR" || appStore.topic.id === "projectsGk") &&
			!auftragsverwaltung.selectedProject) {
            // do not toggle map when list of projects is displayed
            return null;
        }

	    const mapButtonText = auftragsverwaltung.showMap ? "Karte ausblenden" : "Karte einblenden";

        return (
            <Button className={"map"} secondary
                onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
			        this.handleToggleMap();
		        }}>
                <Icon name={"map"} selected/> {mapButtonText}
            </Button>
        );
    }

    private handleToggleMap(): void {
        const {auftragsverwaltung} = this.props;
        const {showMap} = auftragsverwaltung;
        auftragsverwaltung.setShowMap(!showMap);
    }
}
